import { MangoButton, Text, Stack, Input, ColumnContainer, Column, Box } from '@intellihr/blueberry'
import { FormEvent, useState } from 'react'
import { CdnAssetImage } from '../../../services/cdnAssets/CdnAssetImage'
import { useAuth } from '../../../services/authContext/utils'
import { HF_ANALYTICS_LOGO_LIGHT_BACKGROUND_PATH } from '../../../constants'

const LoginForm: React.FC = () => {
  const auth = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleLogin = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    auth.login(username, password)
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <div
        style={{
          position: 'absolute',
          borderRadius: '0.75rem',
          backgroundColor: 'var(--mgo-color-bg-raised)',
          width: '30rem',
          padding: '2rem',
          boxShadow: 'var(--mgo-shadow-raised)',
        }}
      >
        <Stack
          testId='login-box'
          space='xLarge'
        >
          <Box align='center'>
            <CdnAssetImage
              cdnPath={HF_ANALYTICS_LOGO_LIGHT_BACKGROUND_PATH}
              alt='hf-logo'
              style={{ width: '185px' }}
            />
          </Box>
          <form onSubmit={handleLogin}>
            <Stack testId='login-form'>
              <Input
                value={username}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setUsername(event.target.value)}
                label='Your work email'
                id='username'
                required={true}
                testId='username-input'
              />
              <Input
                value={password}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
                label='Password'
                id='password'
                type='password'
                required={true}
                testId='password-input'
              />
              <ColumnContainer>
                <Column size='stretch'>
                  <MangoButton
                    disabled={!username || !password}
                    variant='primary'
                    loading={auth.isLoginAuthProcessing}
                    testId='login-button'
                    type='submit'
                  >
                    Log In
                  </MangoButton>
                </Column>
                <Column size='content'>
                  <MangoButton
                    testId='forgot-password-link'
                    variant='tertiary'
                    href='https://help.humanforce.com/hc/en-au/articles/12105668917263-Reset-your-Humanforce-Intelligence-Password'
                    openNewTab
                  >
                    Forgot password
                  </MangoButton>
                </Column>
              </ColumnContainer>
            </Stack>
            {/* Hidden input so pressing Enter to submit actually works */}
            <input
              type='submit'
              style={{ display: 'none' }}
              aria-hidden={true}
            />
          </form>
          <Stack
            align='center'
            testId='footer'
          >
            <CdnAssetImage
              cdnPath='brand/brand-line.svg'
              alt='hf-brand-line'
            />
            <Text
              size='small'
              testId='copyright'
            >
              <span style={{ color: '#AEB9C9' }}>© Humanforce Holdings Pty Ltd or its affiliates</span>
            </Text>
          </Stack>
        </Stack>
      </div>
    </div>
  )
}

export default LoginForm
